import { z } from 'zod/v4-mini'

export const searchParamsSortingSchema = <
    T extends {
        [k: string]: string | number
        [nu: number]: string
    },
>(
    fieldEnum: T,
    defaultValue: number
) =>
    z.object({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        sortByField: z._default(z.enum(fieldEnum), defaultValue as any),
        sortDirectionDesc: z._default(z.boolean(), false),
    })

export interface SearchParamsSortingSchema<T> {
    sortByField: T
    sortDirectionDesc: boolean
}

export const searchParamsSortingDefaultValues = (
    defaultValue: number
): SearchParamsSortingSchema<any> => ({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    sortByField: defaultValue as any,
    sortDirectionDesc: false,
})
